<script setup>
import ProspectTable from '@frontJs/components/tables/projectManagement/apikom/ProspectTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h, onMounted, ref } from 'vue';

const loading = ref(true);

const data = ref({
    all: 0,
    archived: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.apikom.postProspectCount'), {
            archived: false,
        }),
        axios.post(route('front.projectManagement.apikom.postProspectCount'), {
            archived: true,
        }),
    ])
        .then(([allCountData, archivedCountData]) => {
            data.value.all = allCountData.data.count;
            data.value.archived = archivedCountData.data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Prospects - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Prospects </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                total: data.all,
                content: h(ProspectTable),
            },
            archived: {
                title: 'Archivé',
                total: data.archived,
                content: h(ProspectTable, { archived: true }),
            },
        }"
        :loading="loading"
    />
</template>
